export const text = /^[^\n]+/
